import React from "react";
import "./Footer.css";
import { Col, Container, Row } from "react-bootstrap";
import logo from "../../assets/img/logo.png";
import Idilogo from "../../assets/img/idi_LOGO.png";
import { Link } from "react-router-dom";
import { IoIosArrowForward, IoIosMailUnread } from "react-icons/io";
import { FaPhoneAlt } from "react-icons/fa";
import { BsInstagram } from "react-icons/bs";
import { FaXTwitter } from "react-icons/fa6";
import { FaLocationDot } from "react-icons/fa6";
import { FaFacebookSquare, FaWhatsapp } from "react-icons/fa";
import { FiPhoneCall } from "react-icons/fi";

const MainFooter = () => {
  return (
    <>
      <section className="footer-section">
        <Container fluid>
          <Row className="section-spacing-x section-spacing-y border-bottom ">
            <Col lg={3} className="footer-list mb-3">
              <Link to="/">
                <img
                  src={logo}
                  className="img-fluid mb-2"
                  alt="Indian Diamond Insitute | Passion: Technology: Innovation | Sreehari Diamond Laboratory "
                />
              </Link>

              <p className="mb-0">
                Sreehari Diamond Laboratory is a trusted expert in diamond
                testing and certification, delivering accuracy, authenticity,
                and professional gemological services since 1947.{" "}
              </p>
            </Col>

            <Col lg={3} className="footer-list mb-1 ps-lg-5">
              <h3> Our Links</h3>

              <ul className="list-unstyled d-flex flex-column justify-content-start gap-1 mb-3">
                <li>
                  <Link to="/">
                    <IoIosArrowForward />
                    Home
                  </Link>
                </li>
                <li>
                  <li>
                    <Link to="/about-us">
                      <IoIosArrowForward />
                      About Us
                    </Link>
                  </li>
                </li>
                <li>
                  <li>
                    <Link to="/services">
                      <IoIosArrowForward />
                      Services
                    </Link>
                  </li>
                </li>
                <li>
                  <li>
                    <Link to="/research">
                      <IoIosArrowForward />
                      Research
                    </Link>
                  </li>
                </li>
                <li>
                  <li>
                    <Link to="/our-store">
                      <IoIosArrowForward />
                      Our Store
                    </Link>
                  </li>
                </li>
                <li>
                  <li>
                    <Link to="/4cs-of-diamonds">
                      <IoIosArrowForward />
                      4Cs Education
                    </Link>
                  </li>
                </li>
                {/* <li>
                  <li>
                    <Link to="/">
                      <IoIosArrowForward />
                      Our Store
                    </Link>
                  </li>
                </li> */}
                <li>
                  <li>
                    <Link to="/contact-us">
                      <IoIosArrowForward />
                      Contact Us
                    </Link>
                  </li>
                </li>
              </ul>
            </Col>
            <Col lg={3} className="footer-list mb-1">
              <h3> Certificate</h3>

              <ul className="list-unstyled d-flex flex-column justify-content-start gap-1 mb-3">
                <li>
                  <Link to="/full-diamond-grading-reports">
                    <IoIosArrowForward />
                    Full Diamond Grading Reports
                  </Link>
                </li>
                <li>
                  <li>
                    <Link to="/diamond-jewelry-reports">
                      <IoIosArrowForward />
                      Diamond Jewelry Reports{" "}
                    </Link>
                  </li>
                </li>
                <li>
                  <li>
                    <Link to="/fancy-diamond-reports">
                      <IoIosArrowForward />
                      Fancy Diamond Reports
                    </Link>
                  </li>
                </li>
                <li>
                  <li>
                    <Link to="/lab-grown-reports">
                      <IoIosArrowForward />
                      Lab Grown Reports
                    </Link>
                  </li>
                </li>
              </ul>
            </Col>
            <Col lg={3} className="footer-list">
              <div className="logo-height">
                <img
                  src={Idilogo}
                  className="img-fluid h-100"
                  alt="Idimemeber"
                />
              </div>
              <ul className="list-unstyled d-flex flex-column justify-content-start gap-3 mb-0">
                <li>
                  {" "}
                  <span className="mb-1">
                    K. Subbiah, B.E., GDGJ <br /> Certified and Professional
                    Gemologist (IDI ALUMNI SURAT)
                  </span>
                </li>
                <li>
                  <a
                    href="https://maps.app.goo.gl/w8R7Ee74imr1L3QEA"
                    target="_blank"
                    className="d-flex align-items-center gap-2"
                  >
                    <span className="align-self-start">
                      {" "}
                      <FaLocationDot />
                    </span>
                    <span>
                      <b>SREEHARI DIAMOND LABORATORY</b> <br />
                      No 3/11 Opposite to Union Bank of India, <br /> Kunjan
                      Chettiyar Street, KaraiKudi, <br /> Sivaganga - 630 001,
                      Tamil Nadu, INDIA.
                    </span>
                  </a>
                </li>
                <li>
                  <a
                    href="tel:+919443736692"
                    className="d-flex align-items-center gap-2"
                  >
                    <span>
                      <FaPhoneAlt />
                    </span>
                    <span>+91 94437 36692</span>
                  </a>
                </li>
                <li>
                  <a
                    href="tel:+919442101562"
                    className="d-flex align-items-center gap-2"
                  >
                    <span>
                      <FaPhoneAlt />
                    </span>
                    <span>+91 94421 01562</span>
                  </a>
                </li>
                <li>
                  <a
                    href="mailto:sreeharidiamondlab@gmail.com"
                    className="d-flex align-items-center gap-2 mail"
                  >
                    <span>
                      <IoIosMailUnread />
                    </span>
                    <span>sreeharidiamondlab@gmail.com </span>
                  </a>
                </li>
              </ul>
            </Col>
          </Row>
          <div className="section-spacing-x d-flex w-100  flex-column flex-md-row justify-content-between align-items-center py-3 powered pb-lg-3 pb-5">
            <a
              target="_black"
              href="https://globaltrendz.com"
              className="order-lg-1 order-2"
            >
              Powered by Global Trendz.
            </a>
            <p className="text-white order-lg-2 order-1 mb-0">
              Copyrights © 2025 <br className="d-md-none" /> SREEHARI DIAMOND
              LABORATORY. <br className="d-md-none" />
              All rights reserved.
            </p>
          </div>
        </Container>
      </section>

      <div className="floating_btn call_icon">
        <a href="https://wa.me/+919360675485" className="whatsapp-btn">
          <FaWhatsapp />
        </a>
      </div>
    </>
  );
};

export default MainFooter;
